import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useLang } from '../../contexts/LanguageContext';
import { ChevronLeft, Cpu } from 'lucide-react';
import { EMZI_COLORS, EMZI_SHADOWS, EMZI_RADIUS } from '../../styles/emziCI';
import AIModelControllerCard from '../../components/admin/AIModelControllerCard';

/**
 * EMZI NEXUS V6.3 - AI Model & Cost Controller Page
 * Dedicated page for AI model selection, cost tracking, and optimization
 * Route: /admin/ai
 * Updated: EMZI CI Standard
 */

const AIModelPage = () => {
  const { user, isAdmin } = useAuth();
  const t = useLang();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAdmin()) {
      navigate('/dashboard');
    }
  }, [isAdmin, navigate]);

  if (!isAdmin()) {
    return null;
  }

  return (
    <div style={{
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      background: EMZI_COLORS.background
    }}>
      {/* Fixed Header - EMZI CI Standard */}
      <div style={{
        background: EMZI_COLORS.primary,
        padding: '20px',
        color: 'white',
        boxShadow: EMZI_SHADOWS.header,
        flexShrink: 0
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          marginBottom: '8px'
        }}>
          <button
            onClick={() => navigate('/admin')}
            style={{
              background: 'rgba(255, 255, 255, 0.2)',
              border: 'none',
              padding: '8px',
              borderRadius: '50%',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'background 0.2s'
            }}
            onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.3)'}
            onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.2)'}
          >
            <ChevronLeft size={20} color="white" />
          </button>
          <div>
            <h1 style={{
              fontSize: '24px',
              fontWeight: '700',
              margin: 0,
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              color: 'white'
            }}>
              <Cpu size={28} strokeWidth={2} />
              {t('admin.aiModel.title')}
            </h1>
            <p style={{
              fontSize: '14px',
              opacity: 0.9,
              margin: '4px 0 0 0',
              color: 'white'
            }}>
              {t('admin.aiModel.subtitle')}
            </p>
          </div>
        </div>
      </div>

      {/* Scrollable Content */}
      <div style={{
        flex: 1,
        overflowY: 'auto',
        overflowX: 'hidden',
        WebkitOverflowScrolling: 'touch',
        scrollBehavior: 'smooth',
        padding: '20px',
        paddingBottom: '100px'
      }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
          <AIModelControllerCard />
        </div>
      </div>
    </div>
  );
};

export default AIModelPage;
